import { createStore } from 'vuex'
import recipes from './modules/recipes.js'
import userdata from './modules/userdata.js'
import preferences from './modules/preferences.js'
import labels from './modules/labels.js'
import profile from './modules/profile.js'
import familyMember from './modules/familyMember.js'
import ingredients from './modules/ingredients.js'
import achievements from './modules/achievements.js'
import appliance from './modules/appliance.js'
import userstorage from './modules/userstorage.js'
import storage from './modules/storage.js'
import products from './modules/products.js'
import appliance_capabilities from './modules/appliance_capabilities.js'
import tickets from './modules/tickets'
import recipeCategory from './modules/recipeCategory'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: (process.env.NODE_ENV !== 'production'? '':'rc4') , isCompression: false, encryptionSecret: 'irinox-s3cr3tPa$$w0rd@123' });
const debug = process.env.NODE_ENV !== 'production'

const store = createStore({
  modules: {
    recipes,
    userdata,
    preferences,
    labels,
    profile,
    familyMember,
    ingredients,
    achievements,
    storage,
    products,
    tickets,
    appliance,
    userstorage,
    appliance_capabilities,
    recipeCategory,
  },
   plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
   strict: debug,
});

export default store;